/* @flow */
import * as React from 'react';
import Text from 'components/Text';
import Heading from 'components/Heading';
import Row from 'components/Row';

import TextAppLinkForm from 'user/components/TextAppLinkForm';

import EventTracking from 'lib/EventTracking';

type State = {
  mobilePlanLinkSent: boolean,
};

export class IndividualPlanLink extends React.Component<*, State> {
  state: State = {
    mobilePlanLinkSent: false,
  };

  handlePlanLinkSubmit = () => {
    this.setState({
      mobilePlanLinkSent: true,
    });
    EventTracking.trackKey('individual_plans.sms_modal_view.send_text.click');
  };

  renderPlanSmsPrompt = (mobilePlanLinkSent: boolean) => {
    const individualPlanDescription = (
      <React.Fragment>
        <Row>
          <Heading data-test="ip-modal-heading" level="2">
            {mobilePlanLinkSent
              ? 'Text sent! Check your phone'
              : 'Open the Remind app on your phone to Upgrade to your Individual Plan'}
          </Heading>
        </Row>
        <Row>
          <Text color="thunder" data-test="ip-modal-text" size="small">
            {mobilePlanLinkSent
              ? 'Follow the link on your phone to upgrade to the Individual Plan.'
              : 'Enter your Phone number and we will text you a link to download the Remind app. Already have the app? The link will direct you to the upgrade purchase page.'}
          </Text>
        </Row>
      </React.Fragment>
    );

    return individualPlanDescription;
  };

  render() {
    return (
      <React.Fragment>
        {this.renderPlanSmsPrompt(this.state.mobilePlanLinkSent)}
        <TextAppLinkForm hasMobilePlanLink handlePlanLinkSubmit={this.handlePlanLinkSubmit} />
      </React.Fragment>
    );
  }
}

export default IndividualPlanLink;
